import React, { useRef, useState } from 'react';
import { PlusIcon } from '@revfluence/fresh-icons/regular/esm';
import { Button } from '@frontend/shadcn/components/ui/button';
import { SectionCard } from '../components/SectionCard';
import { CampaignWorkletsList } from '../CampaignWorkletsList';
import { TWorkletWithoutTypename } from '../CampaignContext';

interface WorkflowStagesSectionProps {
  defaultWorklets?: TWorkletWithoutTypename[];
  parentSpecKey?: string;
  projectId?: number;
}

export const WorkflowStagesSection: React.FC<WorkflowStagesSectionProps> = ({
  defaultWorklets,
  parentSpecKey,
  projectId,
}) => {
  const ref = useRef<{ handleAddWorklet:() => void }>(null);

  const [isAddingNewStage, setIsAddingNewStage] = useState(false);

  const handleAddWorklet = () => {
    ref.current?.handleAddWorklet();
  };

  return (
    <SectionCard
      title="Workflow Stages"
      description="Workflow stages enable you to track and manage tasks as well as member statuses throughout the campaign."
      rightContent={
        <Button
          variant="outline"
          size="xs"
          onClick={handleAddWorklet}
          className="self-start mt-0.5"
          disabled={isAddingNewStage}
        >
          <PlusIcon className="mr-2" />
          Add Stage
        </Button>
      }
    >
      <CampaignWorkletsList
        defaultWorklets={defaultWorklets}
        parentSpecKey={parentSpecKey}
        projectId={projectId}
        showFlexActivationUI
        ref={ref}
        isAddingNew={isAddingNewStage}
        setIsAddingNew={setIsAddingNewStage}
      />
    </SectionCard>
  );
};
